import React from 'react';
import { useSelector } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import Options from '../components/Options';
import { InvData } from '../data';

import '../global-sass/main.scss';

function Widget() {
	const {
		moreRequestData: { siteId, pageAlias, pageId }
	} = useSelector((state) => state);

	if (isBrowser && !window.DDC.InvData) {
		window.DDC.InvData = new InvData();
	}

	const hookProps = {
		siteId,
		pageAlias,
		pageId
	};

	return <Options hookProps={hookProps} />;
}

export default Widget;
